module.exports = __webpack_public_path__ + "img/back-arrow.cb3bdb7b.svg";